import React, { useState } from 'react';
import { MuiBox, MuiDialog } from 'theme/material-ui';
import {
  PersonalInfoInputLabel,
  PersonalInfoSection,
  PersonalInfoFormControl,
  MuiRow,
  PreRegInputBox,
  PhoneIcon
} from '../styled';
import { Button } from '@material-ui/core';
import EditPhoneComponent from 'components/EditPhone';
import { useDispatch } from 'react-redux';
import { sendPreRegPin, validatePreRegPin } from 'store/preRegistration/actions';
import { Alert } from 'components/Alert';
import Logger, { LoggingModule } from 'services/Logger';
import { ProfileUpdateMessages } from 'store/profile/constants';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import { formatPhone } from 'services/formatPhone';
import { PatientInfo } from 'store/preRegistration/types';
import { SendPinProps } from 'store/profile/types';
import Config from 'react-native-config';

interface EditMobileProps {
  initialMobile: string;
  setMobileNumber: (mobileNumber: string) => void;
  patientInfo: PatientInfo;
}

const EditMobilePhone = (props: EditMobileProps) => {
  const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';
  const [mobileModalActive, setMobileModalActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleCancel = () => setMobileModalActive(!mobileModalActive);

  const { initialMobile, setMobileNumber, patientInfo } = props;

  const dispatch = useDispatch();

  const handleSubmit = async (pin: string, numberToSubmit: string) => {
    setIsLoading(true);

    const validateRes = await dispatch(
      validatePreRegPin({ type: 'sms', phone: numberToSubmit, pin }, patientInfo)
    );

    if (validateRes.error) {
      Logger.error(`${LoggingModule.profile}SMS verification failed`, validateRes.error.message);
      setIsLoading(false);

      return Alert.alert(
        ProfileUpdateMessages.VALIDATE_PHONE.title,
        ProfileUpdateMessages.VALIDATE_PHONE.message
      );
    }
    setMobileNumber(numberToSubmit);

    setIsLoading(false);

    return Alert.alert(
      'Phone Verified',
      'The mobile phone number has been verified but you will need to click confirm at the bottom of the page in order to save it to your profile.',
      [
        {
          text: 'OK',
          onPress: () => setMobileModalActive(!mobileModalActive)
        }
      ]
    );
  };

  const mobileProps = {
    initialMobile,
    handleCancel,
    handleSubmit,
    isLoading,
    sendPin: async (data: SendPinProps) => {
      const res = await dispatch(sendPreRegPin(data, patientInfo));
      if (res.error) {
        Alert.alert(
          'There was an issue sending the pin.',
          'Please update your phone at your appointment',
          [
            {
              text: 'OK',
              onPress: () => setMobileModalActive(!mobileModalActive)
            }
          ]
        );
      }
    }
  };

  return (
    <MuiRow>
      <MuiBox>
        <PersonalInfoInputLabel required={!!ALLOW_UPDATE}>Mobile Phone</PersonalInfoInputLabel>
        <PersonalInfoSection>
          <PersonalInfoFormControl required={!!ALLOW_UPDATE}>
            <PhoneIcon>
              <CallOutlinedIcon />
            </PhoneIcon>
            <PreRegInputBox
              variant="outlined"
              name="mobileNumber"
              disabled
              value={formatPhone(initialMobile)}
              InputProps={{
                readOnly: true
              }}
              // eslint-disable-next-line react/jsx-curly-brace-presence
              placeholder={`(___) ___-____`}
            />
          </PersonalInfoFormControl>
          {ALLOW_UPDATE ? (
            <Button color="primary" onClick={() => setMobileModalActive(!mobileModalActive)}>
              Edit
            </Button>
          ) : null}
          <MuiDialog open={mobileModalActive}>
            <EditPhoneComponent {...mobileProps} />
          </MuiDialog>
        </PersonalInfoSection>
      </MuiBox>
    </MuiRow>
  );
};

export default EditMobilePhone;
